<template>
  <v-container style="width: 100%; height: 100%">
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      "
      :style="{
        background: setBackgoundBox(),
      }"
    ></div>

    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        overflow-y: auto;
      "
    >
      <div
        class="d-flex flex-column justify-center align-center"
        style="min-height: 100%"
        :style="{
          color: `${getFontColorBasedOnBg()}`,
        }"
      >
        <div
          v-if="listMember.length > 0"
          class="my-6 text-h5 d-flex align-center"
        >
          <div cols="auto">{{ $t("textSelectUser") }}</div>
        </div>

        <div
          v-if="listMember.length > 0"
          class="d-flex flex-wrap mb-4 list-layout"
          style="gap: 24px"
        >
          <div
            cols="auto"
            v-for="(item, index) in listMember"
            :key="index"
            class="user-card d-flex flex-column align-center"
            style="width: 120px"
            @click="handleSelectProfile(item)"
          >
            <img
              class="w-100"
              :src="item.image_url"
              style="
                border: 1px solid #ffffff;
                border-radius: 8px;
                aspect-ratio: 1;
                object-fit: cover;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
              :style="{
                'background-color': site.color || '#eeeeee',
              }"
            />
            <div class="pa-2">
              <p class="ma-0 name-label" style="overflow-wrap: anywhere">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Axios from "@/config/backend-service";
import { mapState } from "vuex";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";

export default {
  inject: ["isAppLoading"],
  data() {
    return {
      listMember: [],
    };
  },
  created() {
    this.getMyMemberAuth();
  },
  methods: {
    async getMyMemberAuth() {
      this.isAppLoading(true);
      try {
        let list = [];
        const response = await Axios.get(`getMyMemberAuth/${this.mobile}`);
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data.data || [];
          list = [...data];
        }
        list = list.map((x) => {
          x.image_url =
            x.profile_path || require("@/assets/images/user-only.svg");
          return x;
        });
        if (list.length == 1) {
          this.$store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", {
            id: list[0].id,
          });
          if (this.urlRedirect) {
            this.$router.push({
              path: this.urlRedirect,
            });
          } else {
            const targetRoute = this.$router.resolve({
              name: "main",
            });
            window.location.href = targetRoute.href;
          }
        } else {
          this.listMember = [...list];
        }
      } catch (err) {
        console.log("getMyMemberAuth", err);
      }
      this.isAppLoading(false);
    },
    async handleSelectProfile(param) {
      this.isAppLoading(true);
      try {
        const response = await Axios.post(`exchangeUser/${param?.id}`, {
          token: localStorage.getItem("token"),
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          localStorage.setItem("token", dataResponse.data?.access_token || "");
          this.$store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", {
            id: param?.id,
          });
          if (this.urlRedirect) {
            this.$router.push({
              path: this.urlRedirect,
            });
          } else {
            const targetRoute = this.$router.resolve({
              name: "main",
            });
            window.location.href = targetRoute.href;
          }
        } else if (dataResponse?.status == "join") {
          this.$store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", {
            id: param?.id,
          });
          if (this.urlRedirect) {
            this.$router.push({
              path: this.urlRedirect,
            });
          } else {
            const targetRoute = this.$router.resolve({
              name: "main",
            });
            window.location.href = targetRoute.href;
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: this.$t("loginFail"),
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (err) {
        console.log("exchangeUser", err);
        this.$swal.fire({
          icon: "error",
          text: err?.response?.data?.message || this.$t("loginFail"),
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isAppLoading(false);
    },
    getFontColorBasedOnBg() {
      const _color = this.site?.color || "#FFFFFF";
      const res = getFontColorBasedOnBg(_color, "bw");
      return res;
    },
    setBackgoundBox() {
      const _color = this.site?.color || "#FFFFFF";
      const darken = adjustHslBrightness(_color, -20);
      // const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      _style = `radial-gradient(circle, ${_color} 0%, ${darken} 100%)`;
      return _style;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    ...mapState("login", ["urlRedirect", "mobile"]),
  },
};
</script>

<style scoped>
.list-layout {
  max-width: 840px;
  transition: all 0.3s ease;
}
@media (min-width: 1263px) {
  .list-layout {
    max-width: 1128px;
  }
}
@media (max-width: 959px) {
  .list-layout {
    max-width: 552px;
  }
}
@media (max-width: 599px) {
  .list-layout {
    max-width: 264px;
  }
}

.user-card {
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.user-card:hover {
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; */
}

.name-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>